// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"30760836","498":"44a40f4a","703":"14e99ff8"}[chunkId] + ".chunk.js";
};